import { useState } from "react";
import emailjs from "@emailjs/browser";

export default function Register() {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [otp, setOtp] = useState("");
  const [generatedOtp, setGeneratedOtp] = useState("");
  const [step, setStep] = useState(1);

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // EMAILJS CONFIG
  const SERVICE_ID = "service_7bowv5s";
  const TEMPLATE_ID = "template_ifyum4c";
  const PUBLIC_KEY = "LQ4-Vq2se-u97GyF5";

  // STEP 1 — Send OTP
  const sendOtp = (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!username || !email || !password) {
      setError("All fields are required before sending OTP.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    // Generate OTP
    const newOtp = Math.floor(100000 + Math.random() * 900000).toString();
    setGeneratedOtp(newOtp);

    // Send using EmailJS
    emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      { email: email, otp: newOtp },
      PUBLIC_KEY
    );

    setStep(2);
    setSuccess("OTP sent to your email!");
  };

  // STEP 2 — Verify OTP
  const verifyOtp = (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (otp !== generatedOtp) {
      setError("Invalid OTP! Please try again.");
      return;
    }

    // Store user in localStorage
    const userData = { username, email, password };
    localStorage.setItem("user", JSON.stringify(userData));

    setSuccess("Registration successful!");
    setTimeout(() => {
      window.location.href = "/login";
    }, 1500);
  };

  return (
    <div className="flex justify-center items-center h-screen bg-gray-100">
      <form className="bg-white p-8 rounded-2xl shadow-xl w-96">
        <h2 className="text-3xl font-bold text-center mb-6 text-gray-800">
          Create Account
        </h2>

        {error && <p className="text-red-500 text-center mb-3">{error}</p>}
        {success && (
          <p className="text-green-600 text-center mb-3">{success}</p>
        )}

        {step === 1 && (
          <>
            <input
              type="text"
              placeholder="Username"
              className="w-full p-3 mb-3 border rounded-lg"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />

            <input
              type="email"
              placeholder="Email Address"
              className="w-full p-3 mb-3 border rounded-lg"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <input
              type="password"
              placeholder="Password"
              className="w-full p-3 mb-3 border rounded-lg"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <input
              type="password"
              placeholder="Confirm Password"
              className="w-full p-3 mb-5 border rounded-lg"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />

            <button
              onClick={sendOtp}
              className="bg-black text-white w-full py-3 rounded-lg hover:bg-gray-800"
            >
              Send OTP
            </button>
          </>
        )}

        {step === 2 && (
          <>
            <input
              type="number"
              placeholder="Enter OTP"
              className="w-full p-3 mb-3 border rounded-lg"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
            />

            <button
              onClick={verifyOtp}
              className="bg-green-600 text-white w-full py-3 rounded-lg"
            >
              Verify OTP & Register
            </button>

            <button
              onClick={() => setStep(1)}
              className="w-full mt-3 bg-gray-300 text-black py-2 rounded"
            >
              Back
            </button>
          </>
        )}
      </form>
    </div>
  );
}
